import { Group, MantineTheme, Text } from "@mantine/core";
import { CircleFilledIcon } from "@mcurros2/microm";
import { IconAlertHexagonFilled, IconAlertSquareFilled, IconAlertTriangleFilled, IconCheck } from "@tabler/icons-react";
import { ReactNode } from "react";

export function DisponibleEnRutasViewColumnsOverrides(theme: MantineTheme) {
    return {
        // Horario
        6: {
            render: (value: unknown) => (!value) ? <Group style={{ gap: '.5rem' }} noWrap>
                <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                <Text truncate>Sin horario asignado</Text>
            </Group> : value as ReactNode
        },

        // Horas semanales disponibles
        7: {
            render: (value: unknown) => {
                const num = Number.parseFloat(value as string);
                const val: number | null = ((value as string) === "") ? null : num;
                if (val === null) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>Sin rutas asignadas</Text>
                    </Group>
                }
                if (val && val > 0) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertSquareFilled style={{ color: theme.colors.pink[6], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>{value as ReactNode} horas disponibles</Text>
                    </Group>
                }
                if (val && val < 0) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertTriangleFilled style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text>{value as ReactNode} horas sobreasignadas</Text>
                    </Group>
                }
                if (val === 0.00) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <CircleFilledIcon mr="xs" width="1.3rem" icon={<IconCheck size="0.9rem" />} />
                        <Text>Horas totales asignadas</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },

        // Baja
        10: {
            render: (value: unknown) => (value) ? <Group style={{ gap: '.5rem' }} noWrap>
                <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                <Text truncate>{value as ReactNode}</Text>
            </Group> : value as ReactNode
        },

        // Licencia
        11: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.startsWith('De licencia')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertHexagonFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>{val}</Text>
                    </Group>
                }
                if (val.startsWith('Próxima licencia')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconAlertSquareFilled style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>{value as ReactNode}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },

    }
}